import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';
import BlogApp from './BlogApp';
import './css/index.css';
import { SsrProvider } from './ssr/SsrProvider';

ReactDOM.hydrateRoot(
    document.getElementById('app') as HTMLElement,
    <React.StrictMode>
        <BrowserRouter>
            <SsrProvider
                value={{
                    ssrData: window.__SSR_DATA__ || {},
                }}
            >
                <HelmetProvider>
                    <BlogApp />
                </HelmetProvider>
            </SsrProvider>
        </BrowserRouter>
    </React.StrictMode>,
);
